export default "__VITE_ASSET__fB9p_L_M__"